import { Box } from "@mui/material"
import Button from "@mui/material/Button"
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles"
import axios from "axios"
import { ConfirmProvider } from "material-ui-confirm"
import React, { useEffect, useState } from "react"
import { Link, Route, Routes } from "react-router-dom"
import { SERVER_URI } from "../utils/config.js"
import Admin from "./admin.js"
import { Configurations } from "./Configurations.js"
import { ReceivedFeedback } from "./Feedbacks/ReceivedFeedback.jsx"
import { Orders } from "./Orders/Orders.jsx"
import { ReceivedOrder } from "./ReceivedOrder/ReceivedOrder.jsx"
import { theme } from "./theme.js"

const App = () => {
	const [authenticated, setAuthenticated] = useState(false)
	const [isLoaded, setIsLoaded] = useState(false)

	useEffect(() => {
		const checkToken = async () => {
			const token = localStorage.getItem("adminToken")
			if (token) {
				axios.defaults.headers.common["Authorization"] = `Token ${token}`
				try {
					await axios.get(`${SERVER_URI}/verify-token`)
					setAuthenticated(true)
				} catch (e) {
					localStorage.removeItem("adminToken")
					axios.defaults.headers.common["Authorization"] = ""
				}
			}
			setIsLoaded(true)
		}
		checkToken()
	}, [])

	return (
		<>
			<StyledEngineProvider injectFirst>
				<ThemeProvider theme={theme}>
					{/* ConfirmProvider antaa ohjelmalle popup-napin toimintojen varmistukseen käyttäjältä */}
					<ConfirmProvider>
						{/* Navigation for routes */}
						<Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
							<Box>
								<Link to="/admin/tilaukset">
									<Button variant="contained" color="primary" style={{ margin: 5 }}>
										Tilaukset
									</Button>
								</Link>
								<Link to="/admin/asetukset">
									<Button variant="contained" color="primary" style={{ margin: 5 }}>
										Admin
									</Button>
								</Link>
								<Link to="/admin/hallinta">
									<Button variant="contained" color="primary" style={{ margin: 5 }}>
										Asetukset
									</Button>
								</Link>
							</Box>
							<Box>
								{authenticated && (
									<Button
										color="primary"
										variant="contained"
										onClick={() => {
											setAuthenticated(false)
											localStorage.removeItem("adminToken")
											axios.defaults.headers.common["Authorization"] = ""
										}}>
										Kirjaudu ulos
									</Button>
								)}
							</Box>
						</Box>
						{isLoaded && (
							<Routes>
								<Route
									path="/admin/"
									element={<Admin authenticated={authenticated} setAuthenticated={setAuthenticated} />}
								/>
								<Route path="/admin/tilaukset" element={<Orders />} />
								<Route
									path="/admin/asetukset"
									element={<Admin authenticated={authenticated} setAuthenticated={setAuthenticated} />}
								/>
								<Route
									path="/admin/hallinta"
									element={<Configurations authenticated={authenticated} setAuthenticated={setAuthenticated} />}
								/>
								<Route path="/admin/tilaus/:id" element={<ReceivedOrder />} />
								<Route path="/admin/palaute/:id" element={<ReceivedFeedback />} />
								<Route
									path="/*"
									element={<Admin authenticated={authenticated} setAuthenticated={setAuthenticated} />}
								/>
							</Routes>
						)}
					</ConfirmProvider>
				</ThemeProvider>
			</StyledEngineProvider>
		</>
	)
}

export default App
